/* Custom Modal Component - React 19 Compatible */
import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from './CustomModal.jsx';

const Popup = (props) => {
  return (
    <CustomModal
      onClose={props.onClose}
      title={props.title}
      subtitle={props.subtitle}
      isLoading={props.isLoading}
    >
      {props.children}
    </CustomModal>
  );
}

Popup.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  isLoading: PropTypes.bool
}

Popup.defaultProps = {
  title: "",
  subtitle: "",
  isLoading: false
}

export default Popup;
